// FmnWatermark — a large faint forget-me-not petal that sits behind a
// section's content, absolutely positioned, pointer-events-none. Drop it
// inside any section to give white space a quiet brand pulse without
// distracting the reader.
import { ForgetMeNotIcon } from "./ForgetMeNotIcon";

export function FmnWatermark({
    size = 520,
    position = "right",   // "right" | "left" | "bottom-right" | "bottom-left"
    opacity = 0.05,
    rotate = -8,
}) {
    const pos = {
        right:        { top: "10%",  right: "-8%", left: "auto", bottom: "auto" },
        left:         { top: "10%",  left: "-8%",  right: "auto", bottom: "auto" },
        "bottom-right": { bottom: "-6%", right: "-6%", top: "auto", left: "auto" },
        "bottom-left":  { bottom: "-6%", left: "-6%",  top: "auto", right: "auto" },
    }[position] || {};
    return (
        <div
            aria-hidden="true"
            className="absolute pointer-events-none select-none"
            style={{
                ...pos,
                opacity,
                transform: `rotate(${rotate}deg)`,
                zIndex: 0,
            }}
        >
            <ForgetMeNotIcon size={size} />
        </div>
    );
}
